
<!--Page 2 - Roles Activity Main-->

<template>
  <div class="page5 animated fadeIn" v-if="items">
    <div class="container">
      <h3 class="title animated fadeIn">{{items.page1.title}}</h3>
      <p v-html="items.page1.text" class="animated fadeIn"></p>
    </div>
    <div>
      <img src="media/page1/warehouse.png"/>
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {

    };
  },

  computed: {
    location() {
      return this.$store.state.scormLMS.location
    },
    items() {
      return this.$store.state.items
    }
  },

  methods: {
    checkCue() {
      //BOILERPLATE FOR RUNNING AN INTERVAL
      // var self = this
      // if(Math.floor(self.$refs.audio1.currentTime) == 3){
      //   self.vis1 = "visible"
      // }
    },
    runInterval() {
      //BOILERPLATE FOR RUNNING AN INTERVAL
      this.interval = setInterval(this.checkCue, 100);
    },
    next() {
      this.$store.commit('scormLMS/locationPlus');
    }
  },
  mounted() {
  //JIRA POSITIONING
  this.$store.commit("scormLMS/changeUserLocation", "MA KPIs: Page 5");
  this.$store.commit('contTrue');

  },
  beforeDestroy() {
    //BOILERPLATE FOR RUNNING AN INTERVAL
    clearInterval(this.interval);
  },
  components: {},
  props: []
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// Page5.vue?1f17ae20